import { render, staticRenderFns } from "./store-badge.vue?vue&type=template&id=cc6cef10&"
import script from "./store-badge.vue?vue&type=script&lang=js&"
export * from "./store-badge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports